import { Auxiliars } from "helpers";


export interface IFeedback {
  _id: string;
  name: string;
  email: string;
  rating: number;
  comment: string;
};

export const createDefaultFeedback = (): IFeedback => ({
  _id: Auxiliars.generateObjectId(),
  name: "",
  email: "",
  rating: 0,
  comment: "",
});